var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09992 11.5964C9.39488 9.76182 12.2589 8.55233 13.6919 7.96797C17.7834 6.2995 18.6335 6.00967 19.1877 6.0001C19.3095 5.998 19.5821 6.02761 19.7586 6.16804C19.9076 6.28661 19.9486 6.44679 19.9683 6.55921C19.9879 6.67163 20.0123 6.92773 19.9929 7.12784C19.7712 9.41185 18.8118 14.9545 18.3237 17.5127C18.1172 18.5951 17.7105 18.958 17.3169 18.9936C16.4613 19.0707 15.8116 18.4392 14.9829 17.9067C13.6862 17.0733 12.9537 16.5545 11.695 15.7413C10.2404 14.8015 11.1834 14.285 12.0124 13.4409C12.2293 13.22 15.999 9.8583 16.0719 9.55334C16.0811 9.5152 16.0895 9.37304 16.0034 9.29797C15.9172 9.2229 15.7901 9.24857 15.6983 9.26899C15.5683 9.29792 13.4968 10.6403 9.48389 13.2961C8.89591 13.6919 8.36333 13.8848 7.88616 13.8747C7.36012 13.8635 6.34822 13.5831 5.59598 13.3433C4.67333 13.0493 3.94002 12.8938 4.00388 12.3944C4.03714 12.1343 4.40248 11.8683 5.09992 11.5964Z",
    fill: "#388AF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram_icon.3d6209635db9bd1c110224aef82e153e.svg";
export { ForwardRef as ReactComponent };